/**
 * Done step: celebratory summary + "Start Predicting" (→ first Monkey pick).
 * See specs/onboarding-questionnaire/spec.md (Story 4).
 */

import { View, Text, Pressable } from 'react-native';
import { AnimatedMonkey } from '../../AnimatedMonkey/AnimatedMonkey';
import { onboardingStyles as s, C } from '../OnboardingFlow.styles';
import { ONBOARDING_TEST_IDS, ONBOARDING_COPY } from '../OnboardingFlow.constants';

interface DoneStepProps {
  name: string;
  followingCount: number;
  onStart: () => void;
}

export function DoneStep({ name, followingCount, onStart }: DoneStepProps) {
  return (
    <>
      <View style={s.doneBody}>
        <AnimatedMonkey size={200} />
        <Text style={s.doneTitle}>{ONBOARDING_COPY.doneTitle(name)}</Text>
        <Text style={s.doneSub}>{ONBOARDING_COPY.doneSub}</Text>

        <View style={s.summaryCard}>
          <View style={s.summaryRow}>
            <Text style={s.summaryLabel}>{ONBOARDING_COPY.doneUsernameLabel}</Text>
            <Text style={s.summaryValue}>{name}</Text>
          </View>
          <View style={s.summaryDivider} />
          <View style={s.summaryRow}>
            <Text style={s.summaryLabel}>{ONBOARDING_COPY.doneFollowingLabel}</Text>
            <Text style={[s.summaryValue, { color: C.good }]}>
              {followingCount > 0 ? ONBOARDING_COPY.doneFollowing(followingCount) : ONBOARDING_COPY.doneFollowingNone}
            </Text>
          </View>
        </View>
      </View>

      <View style={s.footer}>
        <Pressable
          onPress={onStart}
          testID={ONBOARDING_TEST_IDS.DONE_CTA}
          accessibilityRole="button"
          accessibilityLabel={ONBOARDING_COPY.doneCta}
          style={({ pressed }) => [s.primaryButton, pressed && s.pressed]}
        >
          <Text style={s.primaryButtonText}>{ONBOARDING_COPY.doneCta}</Text>
        </Pressable>
      </View>
    </>
  );
}
